var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-navbar bg-danger"},[_vm._v(" dadwda ")])
}
var staticRenderFns = []

export { render, staticRenderFns }